<template>
	<el-dialog :visible.sync="dialogVisible" width="50%" :append-to-body="true">
		<template slot="title">
			<div class="history-title">
				<ChatAvatar class="avatar" :avatar="conversation.object_avatar" borderRadius="3px" size="30" /> <span>{{ conversation.object_name }}</span>
			</div>
			<el-input clearable v-model="searchHistoryKeyword" size="mini" :placeholder="this.$t('chatHistory.enterChatContent')"></el-input>
			<div class="back" v-show="isViewContext">
				<el-button size="mini" @click="handleViewContext()">{{ $t("chatHistory.back") }}</el-button>
			</div>
		</template>

		<!-- 聊天记录 -->
		<div v-show="isHistory" v-loading="loading" class="messages-container" ref="scrollHistory">
			<ChatHistoryMessage :messages="historyMessages" @handle-image-view="handleImageView" @handle-video-viewer="handleVideoViewer" />
		</div>
		<!-- 搜索聊天记录 -->
		<div v-show="isSearchHistory" v-loading="loading" :class="!isViewContext ? 'messages-container-view' : ''" ref="scrollSearchHistory">
			<ChatHistoryMessage
				:messages="searchHistoryMessages"
				@handle-image-view="handleImageView"
				@handle-video-viewer="handleVideoViewer"
				:searchHistoryKeyword="searchHistoryKeyword"
				:conversation="conversation"
				:isViewContext="isViewContext"
				@handle-view-context="handleViewContext"
				ref="viewContextHistory"
			/>
		</div>
	</el-dialog>
</template>

<script>
import ChatHistoryMessage from "./chat-history-message.vue";
import ChatAvatar from "./chat-avatar.vue";
import { getMessages } from "@/services/api-v2/api-v2";
import _ from "lodash";

export default {
	name: "ChatHistory",

	components: {
		ChatAvatar,
		ChatHistoryMessage,
	},

	props: {
		conversation: {
			type: Object,
			required: false,
			default: null,
		},
		height: {
			type: Number,
			required: false,
			default: 550,
		},
	},

	data() {
		return {
			dialogVisible: false,
			// 加载中
			loading: false,

			// 聊天记录
			isHistory: true,
			historyMessages: [],
			historyCurrentPage: 1,
			historyLastPage: 0,

			// 搜索聊天记录
			isSearchHistory: false,
			searchHistoryMessages: [],
			searchHistoryCurrentPage: 1,
			searchHistoryLastPage: 0,
			searchHistoryKeyword: "",

			pageSize: 20,

			isViewContext: false,
		};
	},

	methods: {
		async getMessages() {
			this.loading = true;
			try {
				if (this.conversation.object_type === "personal") {
					const { data: messages, meta } = await getMessages(this.conversation.object_id, null, this.historyCurrentPage, this.pageSize);
					this.historyMessages = messages.concat(this.historyMessages);
					this.historyCurrentPage = meta.current_page;
					this.historyLastPage = meta.last_page;
					this.pageSize = _.toNumber(meta.per_page);
				} else {
					const { data: messages, meta } = await getMessages(null, this.conversation.object_id, this.historyCurrentPage, this.pageSize);
					this.historyMessages = messages.concat(this.historyMessages);
					this.historyCurrentPage = meta.current_page;
					this.historyLastPage = meta.last_page;
					this.pageSize = _.toNumber(meta.per_page);
				}
			} catch (error) {
				this.$message.error(error);
			}
			this.loading = false;
		},

		// 搜索历史消息
		async getSearchMessages() {
			this.loading = true;
			try {
				if (this.conversation.object_type === "personal") {
					const { data: messages, meta } = await getMessages(
						this.conversation.object_id,
						null,
						this.searchHistoryCurrentPage,
						this.pageSize,
						this.searchHistoryKeyword
					);
					this.searchHistoryMessages = messages.concat(this.searchHistoryMessages);
					this.searchHistoryCurrentPage = meta.current_page;
					this.searchHistoryLastPage = meta.last_page;
					this.pageSize = _.toNumber(meta.per_page);
				} else {
					const { data: messages, meta } = await getMessages(
						null,
						this.conversation.object_id,
						this.searchHistoryCurrentPage,
						this.pageSize,
						this.searchHistoryKeyword
					);
					this.searchHistoryMessages = messages.concat(this.searchHistoryMessages);
					this.searchHistoryCurrentPage = meta.current_page;
					this.searchHistoryLastPage = meta.last_page;
					this.pageSize = _.toNumber(meta.per_page);
				}
			} catch (error) {
				this.$message.error(error);
			}

			this.loading = false;
		},

		async show() {
			this.historyMessages = [];
			this.searchHistoryMessages = [];
			this.searchHistoryKeyword = "";
			this.dialogVisible = true;
			this.historyCurrentPage = 1;
			this.searchHistoryCurrentPage = 1;
			await this.getMessages();
			this.scrollHistoryBottom();
		},

		// 图片查看点击事件
		handleImageView(message) {
			this.$emit("handle-image-view", message);
		},
		// 媒体查看点击事件
		handleVideoViewer(message) {
			this.$emit("handle-video-viewer", message);
		},

		// 历史记录滚动到底部
		scrollHistoryBottom() {
			this.$nextTick(() => {
				const scrollHistory = this.$refs["scrollHistory"];
				scrollHistory.scrollTop = scrollHistory.scrollHeight - scrollHistory.clientHeight;
				scrollHistory.addEventListener("scroll", this.handleHistoryScroll, true);
			});
		},
		//搜索历史历史记录滚动到底部
		scrollSearchHistoryBottom() {
			this.$nextTick(() => {
				const scrollSearchHistory = this.$refs["scrollSearchHistory"];
				scrollSearchHistory.scrollTop = scrollSearchHistory.scrollHeight - scrollSearchHistory.clientHeight;
				scrollSearchHistory.addEventListener("scroll", this.handleSearchHistoryScroll, true);
			});
		},

		// 聊天记录滚动事件
		async handleHistoryScroll(e) {
			if (e.target.scrollTop === 0 && !this.loading) {
				if (this.historyCurrentPage === this.historyLastPage) {
					return;
				}
				this.historyCurrentPage += 1;
				const mountedScrollTop = e.target.scrollHeight;
				await this.getMessages();
				e.target.scrollTop = e.target.scrollHeight - mountedScrollTop;
			}
		},

		//搜索聊天记录滚动事件
		async handleSearchHistoryScroll(e) {
			if (e.target.scrollTop === 0 && !this.loading) {
				if (this.searchHistoryCurrentPage === this.searchHistoryLastPage) {
					return;
				}
				this.searchHistoryCurrentPage += 1;
				const mountedScrollTop = e.target.scrollHeight;
				await this.getSearchMessages();
				e.target.scrollTop = e.target.scrollHeight - mountedScrollTop;
			}
		},

		handleViewContext() {
			this.isViewContext = !this.isViewContext;
			this.$refs.viewContextHistory.clearCiewContextMessage();
		},
	},
	beforeDestroy() {
		const scrollHistory = this.$refs["scrollHistory"];
		scrollHistory.removeEventListener("scroll", this.handleHistoryScroll, true);
		const scrollSearchHistory = this.$refs["scrollSearchHistory"];
		scrollSearchHistory.removeEventListener("scroll", this.handleSearchHistoryScroll, true);
	},

	watch: {
		searchHistoryKeyword: _.debounce(async function (newValue, oldValue) {
			if (newValue === "") {
				this.searchHistoryCurrentPage = 1;
				this.isHistory = true;
				this.isSearchHistory = false;
				this.isViewContext = false;
				return;
			}
			this.isHistory = false;
			this.isSearchHistory = true;
			this.searchHistoryMessages = [];
			if (!this.loading) {
				await this.getSearchMessages();
			}
			this.scrollSearchHistoryBottom();
		}, 500),
	},
};
</script>

<style lang="less" scoped>
.history-title {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
	> span {
		margin-left: 10px;
	}
}
.messages-container {
	height: 550px;
	overflow: auto;
}
.messages-container-view {
	height: 550px;
	overflow-y: scroll;
}

.back {
	margin-top: 10px;
}
</style>
